<template>
  <v-sheet class="mx-2 pb-2 grey lighten-5" id="step">
    <section>
      <v-tabs v-model="tab">
        <v-tab
          v-for="tab in tabs"
          :key="tab.value + 'Tab'"
          :href="'#' + tab.value"
        >
          <v-icon small class="mr-1">mdi-{{ tab.icon }}</v-icon> {{ tab.text }}
        </v-tab>
        <!-- <v-tab
          key="waitTab"
          href="#wait"
          v-if="step.action.method != 'url' && step.type == StepType.UI"
        >
          <v-icon small class="mr-1">mdi-sleep</v-icon> Wait For
        </v-tab>
        <v-tab
          key="headersTab"
          href="#headers"
          v-if="step.type == StepType.API"
        >
          <v-icon small class="mr-1">mdi-view-list</v-icon>
          Headers
        </v-tab>
        <v-tab
          key="generalTab"
          href="#general"
          v-if="step.type == StepType.API"
        >
          <v-icon small class="mr-1">mdi-text-box-plus-outline</v-icon>
          General
        </v-tab> -->
      </v-tabs>
      <scroll-wrap class="h20" outlined ref="scroller" :draggable="false">
        <v-tabs-items v-model="tab">
          <!-- ACTION -->
          <v-tab-item key="action" value="action">
            <v-row class="mt-1">
              <v-col cols="auto">
                <h4><v-icon>mdi-flash</v-icon> Step Type:</h4>
              </v-col>
              <v-col cols="auto">
                <v-btn-toggle
                  v-model="actionType"
                  mandatory
                  group
                  @change="setAction"
                  :disabled="deactivated"
                >
                  <Tooltip
                    v-for="(at, index) in actionTypesList"
                    :key="index"
                    :content="at.text"
                    :icon="at.icon"
                    :active="!deactivated && !at.disabled"
                    :color="at.color"
                    :dark="at.dark"
                    top
                  >
                    <v-btn
                      :value="at.value"
                      class="mr-1 py-2"
                      small
                      :dark="!deactivated"
                      :color="at.color"
                      :disabled="deactivated || at.disabled"
                      :text="actionType != at.value"
                    >
                      <v-icon>mdi-{{ at.icon }}</v-icon>
                    </v-btn>
                  </Tooltip>
                </v-btn-toggle>
              </v-col>
              <v-spacer> </v-spacer>
            </v-row>
            <v-row class="my-1">
              <v-col cols="6">
                <Tooltip
                  content="Event Action for the step"
                  top
                  :active="!deactivated"
                >
                  <v-autocomplete
                    id="actions"
                    :items="actions"
                    :prepend-inner-icon="'mdi-' + actionIcon"
                    label="Action"
                    :color="actionColor"
                    :menu-props="{ offsetY: true }"
                    v-model="step.action.method"
                    dense
                    hide-details
                    outlined
                    :disabled="deactivated"
                    @change="dataChanged"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item class="px-1">
                        <v-list-item-action class="mx-0">
                          <v-icon small> mdi-{{ getIcon(item.value) }} </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.text }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>
                </Tooltip>
              </v-col>
              <v-col v-if="fields.selector.indexOf(step.action.method) >= 0">
                <Tooltip
                  content="Enter CSS selector of the element"
                  top
                  :active="!deactivated"
                >
                  <v-text-field
                    v-model="step.action.selector"
                    label="Selector"
                    dense
                    clearable
                    :disabled="deactivated"
                    outlined
                    hide-details
                    required
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>
              <v-col v-if="fields.posX.indexOf(step.action.method) >= 0">
                <Tooltip
                  content="Enter screen X position"
                  top
                  :active="!deactivated"
                >
                  <v-text-field
                    v-model="step.action.posX"
                    label="Position X"
                    dense
                    type="number"
                    min="0"
                    :disabled="deactivated"
                    outlined
                    hide-details
                    required
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>
              <v-col v-if="fields.posY.indexOf(step.action.method) >= 0">
                <Tooltip
                  content="Enter screen Y position"
                  top
                  :active="!deactivated"
                >
                  <v-text-field
                    v-model="step.action.posY"
                    label="Position Y"
                    dense
                    type="number"
                    min="0"
                    :disabled="deactivated"
                    outlined
                    hide-details
                    required
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>
              <!-- <v-col
                cols="auto"
                v-if="fields.selector.indexOf(step.action.method) >= 0"
              >
                <Tooltip
                  content="Use Pine3 chrome extension to select an element - feature in progress"
                  altContent="Please install Pine3 chrome extension"
                  right
                  :active="false && !disabled && extension"
                >
                  <v-btn
                    class="my-1 mx-0"
                    fab
                    x-small
                    :disabled="true || disabled || !extension"
                    elevation="0"
                    :dark="false && !disabled && extension"
                    color="blue"
                    @click="fetchSelector"
                  >
                    <v-icon>mdi-eyedropper</v-icon>
                  </v-btn>
                </Tooltip>
              </v-col> -->
              <v-col v-if="fields.fullPage.indexOf(step.action.method) >= 0">
                <Tooltip content="Capture full page" top :active="!deactivated">
                  <v-checkbox
                    :disabled="deactivated"
                    v-model="step.action.fullPage"
                    dense
                    x-small
                    hide-details
                    label="Full-Page"
                  >
                  </v-checkbox>
                </Tooltip>
              </v-col>
              <v-col v-if="fields.url.indexOf(step.action.method) >= 0">
                <Tooltip
                  content="Full URL link to go to"
                  top
                  :active="!deactivated"
                >
                  <v-text-field
                    v-model="step.action.url"
                    label="URL"
                    :disabled="deactivated"
                    outlined
                    dense
                    hide-details
                    required
                    @input="dataChanged"
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>
              <v-col
                cols="auto"
                class="pl-0"
                v-if="fields.url.indexOf(step.action.method) >= 0"
              >
                <Tooltip
                  content="Open URL link in new tab"
                  color="success"
                  top
                  :active="!deactivated"
                >
                  <v-btn
                    icon
                    color="success"
                    x-small
                    :disabled="deactivated"
                    class="mt-2"
                    :href="parseEnv(step.action.url, globalEnv)"
                    target="_blank"
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </Tooltip>
              </v-col>
              <v-col v-if="fields.keyboard.indexOf(step.action.method) >= 0">
                <Tooltip
                  content="Select key name from keyboard"
                  top
                  :active="!deactivated"
                >
                  <v-combobox
                    :items="keyboardKeys"
                    label="Key"
                    :disabled="deactivated"
                    v-model="step.action.key"
                    dense
                    outlined
                    hide-details
                    @change="dataChanged"
                  >
                  </v-combobox>
                </Tooltip>
              </v-col>
            </v-row>
            <v-row class="mb-1">
              <v-col
                cols="6"
                v-if="fields.selectOption.indexOf(step.action.method) >= 0"
              >
                <Tooltip
                  content="Select Option from list"
                  top
                  :active="!deactivated"
                >
                  <v-select
                    v-model="step.action.selectOption"
                    :disabled="deactivated"
                    label="Select an Option"
                    :items="[
                      { text: 'With Value of', value: 'value' },
                      { text: 'With Label of', value: 'label' },
                      { text: 'Element Index', value: 'index' },
                    ]"
                    dense
                    hide-details
                    outlined
                    required
                  >
                  </v-select>
                </Tooltip>
              </v-col>
              <v-col
                cols="6"
                v-if="fields.text.indexOf(step.action.method) >= 0"
              >
                <Tooltip content="Enter text" top :active="!deactivated">
                  <v-text-field
                    v-model="step.action.text"
                    :disabled="deactivated"
                    label="Text"
                    dense
                    hide-details
                    outlined
                    required
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>
              <v-col
                cols="6"
                v-if="fields.number.indexOf(step.action.method) >= 0"
              >
                <Tooltip
                  content="Select Logical Sign"
                  top
                  :active="!deactivated"
                >
                  <v-combobox
                    :items="numberSigns"
                    label="Operator"
                    dense
                    :disabled="deactivated"
                    v-model="step.action.operator"
                    outlined
                    hide-details
                  >
                  </v-combobox>
                </Tooltip>
              </v-col>
              <v-col
                cols="6"
                v-if="fields.number.indexOf(step.action.method) >= 0"
              >
                <Tooltip content="Enter a Number" top :active="!deactivated">
                  <v-text-field
                    v-model="step.action.number"
                    :disabled="deactivated"
                    label="Number"
                    type="number"
                    dense
                    outlined
                    hide-details
                    required
                  >
                  </v-text-field>
                </Tooltip>
              </v-col>

              <v-col
                v-if="fields.form.indexOf(step.action.method) >= 0"
                class="pt-0"
              >
                <AddList
                  v-model="step.action.data"
                  title="Fields:"
                  icon="form-textbox"
                  outlined
                  :disabled="deactivated"
                  @input="dataChanged()"
                  :fields="[
                    {
                      type: 'text',
                      name: 'selector',
                      label: 'Selector',
                    },
                    { type: 'text', name: 'text', label: 'Text Value' },
                  ]"
                />
              </v-col>
              <v-col v-if="fields.textarea.indexOf(step.action.method) >= 0">
                <v-textarea
                  v-model="step.action.data"
                  label="Payload"
                  :placeholder="`{ ... ${step.action.method} data }`"
                  outlined
                  required
                  ref="jsonText"
                  hide-details
                >
                </v-textarea>
                <pre
                  class="json"
                  v-if="prettyFormat"
                  v-text="prettyFormat"
                ></pre>
              </v-col>
            </v-row>
            <v-sheet v-if="fields.payload.indexOf(step.action.method) >= 0">
              <v-row class="mt-2">
                <v-col cols="auto">
                  <v-select
                    :items="payloadTypes"
                    prepend-icon="mdi-database-arrow-right"
                    label="Request Data Type"
                    v-model="step.action.dataType"
                    @change="switchDataType"
                    outlined
                    dense
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-if="fields.textarea.indexOf(step.action.dataType) >= 0"
                >
                  <v-textarea
                    v-model="step.action.data"
                    label="Payload"
                    :placeholder="`{ ... ${step.action.dataType} data }`"
                    outlined
                    required
                    ref="jsonText"
                  >
                  </v-textarea>
                  <pre
                    class="json"
                    v-if="prettyFormat"
                    v-text="prettyFormat"
                  ></pre>
                </v-col>
                <v-col v-if="step.action.dataType == 'form'">
                  <AddList
                    v-model="step.action.data"
                    title="Form Data:"
                    icon="form-textbox"
                    outlined
                    @input="dataChanged()"
                    :disabled="deactivated"
                    :fields="[
                      {
                        type: 'text',
                        name: 'name',
                        label: 'Name',
                      },
                      { type: 'text', name: 'value', label: 'Field Value' },
                    ]"
                  />
                </v-col>
              </v-row>
            </v-sheet>

            <!-- Env -->
            <section v-if="fields.env.indexOf(step.action.method) >= 0">
              <v-divider> </v-divider>
              <v-row>
                <v-col cols="auto">
                  <v-switch
                    class="my-2"
                    color="teal"
                    v-model="activeEnv"
                    :disabled="deactivated"
                  >
                  </v-switch>
                </v-col>
                <v-col>
                  <h4 class="my-2">
                    <v-icon>mdi-tune-variant</v-icon> Save Results to
                    Environment
                  </h4>
                </v-col>
              </v-row>
              <Env v-model="step.env" v-if="activeEnv" @input="dataChanged" />
            </section>
          </v-tab-item>
          <v-tab-item key="wait" value="wait">
            <!-- Waits -->
            <section>
              <v-row>
                <v-col>
                  <v-row class="ma-0">
                    <v-col cols="auto">
                      <v-switch
                        class="my-1"
                        color="teal"
                        v-model="activeWait"
                        hide-details
                        :disabled="deactivated"
                      >
                      </v-switch>
                    </v-col>
                    <v-col class="text-left px-0">
                      <h4 class="mt-2">
                        <Tooltip
                          content="Wait before action is executed"
                          altContent="WaitFor is not available for this step type"
                          top
                          :active="!deactivated"
                        >
                          Wait For
                        </Tooltip>
                      </h4>
                    </v-col>
                  </v-row>
                  <WaitFor
                    v-model="step.waitFor"
                    v-if="activeWait"
                    @input="dataChanged"
                    :disabled="deactivated"
                  />
                </v-col>
                <!-- <v-divider vertical></v-divider>
                <v-col :cols="activeAfterWait || 'auto'">
                  <v-row class="ma-0">
                    <v-col cols="auto" class="px-0">
                      <v-switch
                        class="my-1"
                        color="teal"
                        v-model="activeAfterWait"
                        hide-details
                        :disabled="deactivated"
                      >
                      </v-switch>
                    </v-col>
                    <v-col class="text-left px-0">
                      <h4 class="mt-2">
                        <Tooltip
                          content="Wait after action is executed"
                          altContent="WaitAfter is not available for this step type"
                          top
                          :active="!deactivated"
                        >
                          Wait After
                        </Tooltip>
                      </h4>
                    </v-col>
                  </v-row>
                  <WaitFor
                    v-model="step.waitAfter"
                    v-if="activeAfterWait"
                    @input="dataChanged"
                    :disabled="deactivated"
                  />
                </v-col> -->
              </v-row>
            </section>
          </v-tab-item>
          <v-tab-item key="general" value="general">
            <v-row>
              <v-col>
                <v-expansion-panels accordion flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h4>
                        <v-icon style="flex: none" small>
                          mdi-text-box-plus-outline
                        </v-icon>
                        Description
                      </h4>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="desc">
                      <v-textarea
                        v-model="step.description"
                        label="Step Description"
                        class="white"
                        dense
                        hide-details
                        rows="2"
                        outlined
                      >
                      </v-textarea>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item key="headers" value="headers">
            <v-row class="my-1">
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h4>
                      <Tooltip
                        content="Inject your custome headers to the Step's scope."
                        top
                      >
                        <v-icon :color="activeHeaders ? 'success' : null"
                          >mdi-view-list
                        </v-icon>
                        Headers
                      </Tooltip>
                    </h4>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <RequestHeaders
                      v-model="step.headers"
                      @input="dataChanged"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </scroll-wrap>
      <!-- <v-divider> </v-divider> -->
    </section>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";

import WaitFor from "./WaitFor.vue";
import ScrollWrap from "./ScrollWrap.vue";
import Tooltip from "@/components/Tooltip.vue";
import Env from "./Env.vue";
import { ListObj, SelectItem, Step, StepType } from "@/types";
import VueTypes from "vue-types";
import {
  objNotEmpty,
  parseEnv,
  actionColor,
  actionIcon,
  actionTabList,
  cloneObj,
  actionTypes,
  actionsList,
  keyboardKeys,
  numberSigns,
  payloadTypes,
  fields,
} from "@/utils";
import RequestHeaders from "./RequestHeaders.vue";
import AddList from "./AddList.vue";

export default Vue.extend({
  name: "StepComp",

  components: {
    WaitFor,
    ScrollWrap,
    Tooltip,
    Env,
    RequestHeaders,
    AddList,
  },
  data() {
    return {
      sheet: false,
      actionTypes,
      actionsList,
      keyboardKeys,
      numberSigns,
      payloadTypes,
      actionTabList,
      fields,
      tab: "action",
      StepType,
    };
  },
  props: {
    value: VueTypes.any.def({}),
    disabled: VueTypes.bool.def(false),
  },
  methods: {
    scroll() {
      // activate scrolling
      const scroller = this.$refs.scroller as Element;
      scroller.scroll();
    },
    switchDataType() {
      if (!Array.isArray(this.step.action.data)) {
        this.step.action.data = JSON.parse(this.step.action.data);
      } else {
        this.step.action.data = JSON.stringify(this.step.action.data);
      }
    },
    addToForm() {
      if (!this.step.action.data || !Array.isArray(this.step.action.data)) {
        this.step.action.data = [];
      }
      this.step.action.data.push({
        name: ["new_key_" + (this.step.action.data.length + 1)],
        value: "",
      });
    },
    fixObject() {
      if (this.actions?.length) {
        for (const action of this.actions) {
          const { value } = action;
          switch (value) {
            case "url":
              action.disabled = false;
              break;

            default:
              action.disabled = this.root;
              break;
          }
        }
      }
      if (this.actionTypes?.length) {
        for (const at of this.actionTypes) {
          const { value } = at;
          switch (value) {
            case "misc":
              at.disabled = false;
              break;

            default:
              at.disabled = this.root;
              break;
          }
        }
      }
      // if (!this.step.action?.type) {
      //   this.step.action.type = this.step.action?.method
      //     ? this.getActionType(this.step.action?.method)
      //     : "misc";
      //   // console.log(this.step.action?.type);
      // }
      if (!this.step.waitFor) {
        this.step.waitFor = {};
      }
      // if (!this.step.waitAfter) {
      //   this.step.waitAfter = {};
      // }
      if (!this.step.env) {
        this.step.env = [];
      }
      // if (!this.step.device) {
      //   this.step.device = {};
      // }
    },
    dataChanged(newData: any | undefined = undefined) {
      if (newData) {
        const step: any = this.step;
        for (const key in newData) {
          step[key] = cloneObj(newData[key]);
        }
        // console.log(step);
      }
      this.$store.commit("Plans/checkCurrentPlanChange");
      // this.scroll();
    },
    getActionType(method: string): string | undefined {
      for (const actionType in this.actionsList) {
        const exists: SelectItem[] = this.actionsList[actionType].filter(
          (a: SelectItem) => method === a.value
        );
        if (exists.length) {
          return actionType;
        }
      }
      return undefined;
    },
    setAction() {
      this.step.action.method = this.actions.filter(
        (a: SelectItem) => a.text
      )[0].value;
    },
    parseEnv,
    getIcon(method: string): string {
      return actionIcon[method];
    },
    // TODO
    // fetchSelector() {
    //   const data = {
    //     stepId: this.step.id
    //   };
    //   const event = new CustomEvent("fetchSelector", { detail: data });
    //   document.dispatchEvent(event);
    // }
  },
  computed: {
    prettyFormat(): string | boolean {
      if (this.step.action.data?.length) {
        try {
          // try to parse
          JSON.parse(this.step.action.data);
        } catch (e) {
          return String(e.message);
        }
      }
      return false;
    },
    actions(): SelectItem[] {
      return this.actionsList[this.step.type][this.actionType];
    },
    actionTypesList(): SelectItem[] {
      const actionTypeFields = {
        [StepType.UI]: ["misc", "user", "assert"],
        [StepType.API]: ["request"], // TODO , "assert"],
      };

      return actionTypes.filter((a: SelectItem) =>
        actionTypeFields[this.step.type].includes(a.value)
      );
    },
    tabs(): any[] {
      const actionTabs = {
        [StepType.UI]: ["action", "wait", "general"],
        [StepType.API]: ["action", "headers"],
      };
      return actionTabList.filter((a: SelectItem) =>
        actionTabs[this.step.type].includes(a.value)
      );
    },
    actionType: {
      get(): string {
        return this.step?.action?.type;
      },
      set(type: string) {
        this.step.action.type = type;
      },
    },
    actionMethod(): string {
      return this.step?.action?.method || "screenshot";
    },
    actionColor(): string {
      return actionColor[this.actionType];
    },
    actionIcon(): string {
      return actionIcon[this.actionMethod];
    },
    extension(): boolean {
      return this.$store.getters.getExtension;
    },
    deactivated(): boolean {
      return this.disabled;
    },
    activeWait: {
      get(): boolean {
        return objNotEmpty(this.step.waitFor);
      },
      set(val: boolean) {
        let obj = {};
        if (val) {
          if (this.step.action?.selector) {
            obj = {
              method: "element",
              selector: this.step.action?.selector,
              mandatory: true,
              state: "visible",
              timeout: 30,
            };
          } else if (this.step.action.method == "url") {
            obj = { method: "content", time: 1, mandatory: false, timeout: 30 };
          } else {
            obj = { method: "sleep", time: 1, mandatory: false, timeout: 30 };
          }
        }
        this.step.waitFor = obj;
      },
    },
    // activeAfterWait: {
    //   get(): boolean {
    //     return objNotEmpty(this.step.waitAfter);
    //   },
    //   set(val: boolean) {
    //     let obj = {};
    //     if (val) {
    //       if (this.step.action.method == "url") {
    //         obj = { method: "content", time: 1, mandatory: false };
    //       } else {
    //         obj = { method: "sleep", time: 1, mandatory: false };
    //       }
    //     }
    //     this.step.waitAfter = obj;
    //   },
    // },
    activeEnv: {
      get(): boolean {
        return this.step.env?.length > 0;
      },
      set(val: boolean) {
        const env = [];
        if (val) {
          env.push({ name: "", type: "text", val: "" });
        }
        this.step.env = env;
      },
    },
    activeHeaders: {
      get(): boolean {
        return this.step?.headers && objNotEmpty(this.step.headers);
      },
      set(val: boolean) {
        let obj = {};
        if (val) {
          obj = this.step.headers || {};
        }
        this.step.headers = obj;
      },
    },
    step: {
      get() {
        return this.value;
      },
      set(val: Step) {
        // const step = updateObj()
        console.log(val);

        this.$emit("input", val);
      },
    },
    globalEnv(): ListObj[] {
      return this.$store.getters["Plans/getCurrentPlanGlobalEnv"];
    },
  },
  created() {
    // this.step = this.test;
    // this.fixObject();
    // if (!this.step.action.type) {
    //   this.step.action.type = this.getActionType(this.step.action.method);
    // }
  },
  updated() {
    // this.$emit("changed", this.step);
    this.$store.commit("Plans/checkCurrentPlanChange");
  },
  // destroyed() {
  //   this.closeDisplay();
  // }
});
</script>
<style scoped>
pre.json {
  white-space: pre-wrap;
  color: crimson;
  font-size: 0.8em;
  /* color: #c3c3c3; */
}
#step {
  overflow-x: hidden;
}
.v-expansion-panel-header,
.v-expansion-panel-content.desc div.v-expansion-panel-content__wrap {
  padding: 0.5em !important;
}
</style>
